'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../common/helpers');

var _constants = require('../../common/constants');

var Constants = _interopRequireWildcard(_constants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import mqttclient from '../../../../mqttclient/lib/mqttclient'


var ChatFooter = function (_Component) {
    _inherits(ChatFooter, _Component);

    function ChatFooter(props) {
        _classCallCheck(this, ChatFooter);

        var _this = _possibleConstructorReturn(this, (ChatFooter.__proto__ || Object.getPrototypeOf(ChatFooter)).call(this, props));

        _this._sendMessage = function () {
            if (_this.elChatMessageInput.value.trim() !== "") {
                _this.props.onMessageEntered(Constants.MESSAGE_ACTION_SUBMIT, _this.elChatMessageInput.value.trim());
                _this.props.setLastTypedMessage("");
                _this.elChatMessageInput.value = "";
            }
            _this.elChatMessageInput.focus();
        };

        _this.setTimerToSendMessages = function () {
            var typingMessage = void 0;
            _this.timer = setInterval(function () {
                typingMessage = this.elChatMessageInput.value.trim();
                // console.log("onChange function after 1 sec: ", typingMessage)
                if (typingMessage !== "" && this.state.typingMessage !== typingMessage) {
                    this.setState({
                        typingMessage: typingMessage
                    });
                    // console.log("onFocus function after 1 sec inside")
                    this.props.onMessageEntered(Constants.MESSAGE_ACTION_TYPING, typingMessage);
                }
            }.bind(_this), 500);
        };

        _this.state = {
            typingMessage: ''
        };
        _this.elChatMessageInput = null;
        _this.elChatMessageSend = null;
        _this.timer = null;
        _this.setTimerToSendMessages = _this.setTimerToSendMessages.bind(_this);
        // this.sendTypingMessages = this.sendTypingMessages.bind(this)
        _this.clearTimerToSendMessages = _this.clearTimerToSendMessages.bind(_this);
        return _this;
    }

    _createClass(ChatFooter, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var sendButtonEnable = 'disabled';
            if ((0, _helpers.getChatConfig)().mqttService.isConnected && !this.props.isMeetingEnded && !this.props.nonWorkingHour) {
                sendButtonEnable = '';
            }
            return _react2.default.createElement(
                'div',
                { className: 'panel-footer' },
                _react2.default.createElement(
                    'div',
                    { className: 'input-group' },
                    _react2.default.createElement('input', {
                        id: 'btn-input',
                        ref: function ref(el) {
                            return _this2.elChatMessageInput = el;
                        },
                        type: 'text',
                        disabled: sendButtonEnable,
                        className: 'form-control chat_input',
                        placeholder: 'Type your message here...',
                        onFocus: function onFocus(e) {
                            _this2.props.onMessageEntered(Constants.MESSAGE_ACTION_FOCUS, e.target.value.trim());
                            _this2.clearTimerToSendMessages();
                            _this2.setTimerToSendMessages();
                        },
                        onBlur: function onBlur(e) {
                            _this2.clearTimerToSendMessages();
                        },
                        onChange: function onChange(e) {
                            _this2.props.setLastTypedMessage(e.target.value.trim());
                        },
                        onKeyPress: function onKeyPress(e) {
                            var code = e.keyCode ? e.keyCode : e.which;
                            if (code === 13) {
                                //Enter keycode                        
                                e.preventDefault();
                                _this2._sendMessage();
                            }
                        },
                        onClick: function onClick(e) {
                            e.preventDefault();
                            // this.props.onInputBoxClick()
                        } }),
                    _react2.default.createElement(
                        'span',
                        { className: 'input-group-btn' },
                        _react2.default.createElement(
                            'button',
                            { className: 'btn btn-primary',
                                id: 'btn-chat',
                                disabled: sendButtonEnable,
                                onClick: function onClick(e) {
                                    e.preventDefault();
                                    _this2._sendMessage();
                                    // this.props.onInputBoxClick()
                                } },
                            _react2.default.createElement('i', { className: 'fa fa-paper-plane' })
                        )
                    )
                )
            );
        }
    }, {
        key: 'clearTimerToSendMessages',
        value: function clearTimerToSendMessages() {
            clearInterval(this.timer);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this.timer);
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var lastTypedmessage = "";
            if (this.props.lastTypedMessage) {
                lastTypedmessage = this.props.lastTypedMessage;
            }
            if (this.elChatMessageInput) {
                this.elChatMessageInput.value = lastTypedmessage;
                // this.elChatMessageInput.focus()
            }
        }
    }]);

    return ChatFooter;
}(_react.Component);

exports.default = ChatFooter;


// WEBPACK FOOTER //
// ../chat/lib/components/chatbox/chatfooter.js